import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getUserSegment } from '../../../../api/user';
import { UserSegmentRes } from '../../../../api/user/dto/segment.dto.res';
import { QueryKeys } from '../../../common/react-query/query-keys';

const useUserSegmentQuery = (
  options?: Omit<
    UseQueryOptions<UserSegmentRes | undefined>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: QueryKeys.getUserSegment,
    queryFn: getUserSegment,
    enabled: false,
    ...options,
  });
};

export default useUserSegmentQuery;
